import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetStatuses } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
import FilterValueSelect from "views/components/widgets/overview-configuration/filters/FilterValueSelect";
const StatusFilter = ({ value, onChange, selectedStatuses }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const { statuses, loadingStatuses } = useGetStatuses();
  const statusOptions = useMemo(
    () => statuses.map((status) => ({
      value: status.status,
      label: status.status,
      disabled: selectedStatuses.includes(status.id)
    })),
    [selectedStatuses, statuses]
  );
  if (loadingStatuses) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    FilterValueSelect,
    {
      value,
      onChange,
      placeholder: t("widget_filters.select_status"),
      options: statusOptions
    }
  );
};
export default StatusFilter;
